<!-- src/app/pages/trend/trend.html -->
<div class="w-full trendBlock">
    <!-- Insight summary -->
    <div class="rounded-xl border border-slate-200 bg-white p-4 mb-4">
        <h4>Insight Summary</h4>
        <p class="text-slate-700" [innerHTML]="insightSummaryHtml"></p>
    </div>

    <!-- Health System Focus -->
    <div class="rounded-xl border border-slate-200 bg-white trendChartBlock">
        <div class="trendChart">
            <div class="flex justify-between items-center">
                <h5 class="text-slate-800 font-semibold">Health System Focus</h5>

                <div class="flex items-center gap-4">
                    <!-- Toggle: Line / Bar -->
                    <div class="inline-flex rounded-md border border-slate-300 overflow-hidden">
                        <button type="button" (click)="toggle('line')" class="px-3 py-1.5 text-sm font-semibold transition-colors" [ngClass]="mode === 'line' ? 'barColor text-white' : 'bg-white text-slate-700 hover:bg-slate-50'">Line Graph</button>
                        <button
                            type="button"
                            (click)="toggle('bar')"
                            class="px-3 py-1.5 text-sm font-semibold border-l border-slate-300 transition-colors"
                            [ngClass]="mode === 'bar' ? 'barColor text-white' : 'bg-white text-slate-700 hover:bg-slate-50'"
                        >
                            Bar Graph
                        </button>
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap items-center justify-between gap-3 mb-4 mt-3">
                <div class="flex items-center gap-3">
                    <p-select [options]="metricOptions" [(ngModel)]="metric" optionLabel="label" optionValue="value" styleClass="min-w-[14rem]" placeholder="Metric" (onChange)="onSelectChange()"> </p-select>

                    <p-select [options]="sexOptions" [(ngModel)]="sex" optionLabel="label" optionValue="value" styleClass="min-w-[10rem]" placeholder="Group" (onChange)="onSelectChange()"> </p-select>

                    <!-- Single simulation select -->
                    <p-select [options]="simulationOptions" [(ngModel)]="selectedSimulationId" optionLabel="label" optionValue="value" styleClass="min-w-[18rem]" placeholder="Select scenario" (onChange)="onSimulationSelectionChange($event.value)">
                    </p-select>
                </div>
            </div>

            <!-- Chart + Parameters accordion -->
            <div class="">
                <p-chart [type]="mode" [data]="trendData" [options]="trendOptions"></p-chart>
            </div>
        </div>
        <div class="trendIntervention">
            <!-- src/app/pages/trend/trend.html (minimal changes: add counts + toggle icons) -->

            <!-- Interventions heading -->
            <h6 class="cursor-pointer select-none flex items-center gap-2" (click)="toggleSection('params')">
                <i class="pi" [ngClass]="showInterventions ? 'pi-minus' : 'pi-plus'"></i>
                <span>Interventions ({{ paramGroups.length || 0 }})</span>
            </h6>
            @if (showInterventions) {
            <div>
                <p-accordion [multiple]="false" [(value)]="activeParamIndex" class="mb-4">
                    @if (paramGroups.length) { @for (grp of paramGroups; track grp; let i = $index) {
                    <p-accordion-panel [value]="i">
                        <p-accordion-header>{{ grp.name }}</p-accordion-header>
                        <p-accordion-content>
                            <ul class="list-disc ml-5 text-sm">
                                @for (kv of grp.pairs; track kv) {
                                <li>
                                    <span class="text-slate-600">{{ kv.key }}</span>:
                                    <span class="text-slate-900 font-semibold">{{ kv.val }}</span>
                                </li>
                                }
                            </ul>
                        </p-accordion-content>
                    </p-accordion-panel>
                    } } @else {
                    <p-accordion-panel [value]="0">
                        <p-accordion-header>Interventions</p-accordion-header>
                        <p-accordion-content>
                            <div class="text-sm text-slate-500">No parameters available for this scenario.</div>
                        </p-accordion-content>
                    </p-accordion-panel>
                    }
                </p-accordion>
            </div>
            }

            <!-- Costmetrics heading -->
            <h6 class="cursor-pointer select-none flex items-center gap-2" (click)="toggleSection('cost')">
                <i class="pi" [ngClass]="showCostmetrics ? 'pi-minus' : 'pi-plus'"></i>
                <span>Costmetrics ({{ costGroups.length || 0 }})</span>
            </h6>
            @if (showCostmetrics) {
            <div>
                <p-accordion [multiple]="false" [(value)]="activeCostIndex">
                    @if (costGroups.length) { @for (grp of costGroups; track grp; let i = $index) {
                    <p-accordion-panel [value]="i">
                        <p-accordion-header>{{ grp.name }}</p-accordion-header>
                        <p-accordion-content>
                            <ul class="list-disc ml-5 text-sm">
                                @for (kv of grp.pairs; track kv) {
                                <li>
                                    <span class="text-slate-600">{{ kv.key }}</span>:
                                    <span class="text-slate-900 font-semibold">{{ kv.val }}</span>
                                </li>
                                }
                            </ul>
                        </p-accordion-content>
                    </p-accordion-panel>
                    } } @else {
                    <p-accordion-panel [value]="0">
                        <p-accordion-header>Costmetrics</p-accordion-header>
                        <p-accordion-content>
                            <div class="text-sm text-slate-500">No costmetrics available for this scenario.</div>
                        </p-accordion-content>
                    </p-accordion-panel>
                    }
                </p-accordion>
            </div>
            }
        </div>
    </div>
</div>
